export const APP_VERSION = 'v2.0 · Feb 2026';
